import Api from './Api';
import Server from './index';

class SpreadsheetApi extends Api {
  url = 'spreadsheets';
  getEmails(id) {
    return Server.__getRequest(`/spreadsheets/${id}/emails`);
  }
}

const singleton = new SpreadsheetApi();
export default singleton;
